/// <amd-module name="VSSUI/Intersection" />
export { Intersection, IIntersectionContext, IntersectionContext } from "VSSUI/Components/Intersection/Intersection";
export { IIntersectionProps } from "VSSUI/Components/Intersection/Intersection.Props";
